import React, { useEffect, useRef } from 'react';
import './FutureTrade.css';

const TradingViewWidget = ({ symbol }) => {
    const containerRef = useRef();

    useEffect(() => {
        containerRef.current.innerHTML = `
      <div class="tradingview-widget-container__widget"></div>
    `;

        const script = document.createElement("script");
        script.src = "https://s3.tradingview.com/external-embedding/embed-widget-symbol-overview.js";
        script.type = "text/javascript";
        script.async = true;
        script.innerHTML = `
    {
      "lineWidth": 2,
      "lineType": 0,
      "chartType": "bars",
      "fontColor": "rgb(106, 109, 120)",
      "gridLineColor": "rgba(242, 242, 242, 0.06)",
      "volumeUpColor": "rgba(34, 171, 148, 0.5)",
      "volumeDownColor": "rgba(247, 82, 95, 0.5)",
      "backgroundColor": "#17171A",
      "widgetFontColor": "#DBDBDB",
      "upColor": "#22ab94",
      "downColor": "#f7525f",
      "borderUpColor": "#22ab94",
      "borderDownColor": "#f7525f",
      "wickUpColor": "#22ab94",
      "wickDownColor": "#f7525f",
      "colorTheme": "dark",
      "isTransparent": false,
      "locale": "en",
      "chartOnly": true,
      "scalePosition": "right",
      "scaleMode": "Normal",
      "fontFamily": "-apple-system, BlinkMacSystemFont, Trebuchet MS, Roboto, Ubuntu, sans-serif",
      "valuesTracking": "1",
      "changeMode": "price-and-percent",
      "symbols": [
        ["${symbol}|1M"]
      ],
      "dateRanges": [
        "1d|1",
        "1m|30",
        "3m|60",
        "12m|1D",
        "60m|1W",
        "all|1M"
      ],
      "fontSize": "10",
      "headerFontSize": "small",
      "autosize": true,
      "width": "100%",
      "height": "100%",
      "noTimeScale": false,
      "hideDateRanges": false
    }`;

        containerRef.current.querySelector(".tradingview-widget-container__widget").appendChild(script);
    }, [symbol]);

    return (
        <div
            className="tradingview-widget-container"
            style={{ height: '100%', minHeight: '400px' }}
            ref={containerRef}
        ></div>
    );

};

export default TradingViewWidget;
